'use client'

import { StoreHistoryList } from '../StoreHistoryList'

import { Page } from '@/shared/ui/Page'

export function StoreHistoryPage() {
  return (
    <Page className="bg-[#0389D5] bg-[url('/bgs/store-page.svg')]">
      <StoreHistoryList />
    </Page>
  )
}
